import $ from "jquery";
import { NavigatorType } from "../Enums/NavigatorType";
import { NavigateFunction } from "react-router-dom";
import { NavigationClient, NavigationOptions } from "@azure/msal-browser";
import moment from 'moment'
import { ICompanyModel } from "../models/DTO/CompanyModel";
import { IBoardMeetingModel } from "../models/DTO/BoardMeetingModel";
import { IUserModel } from "../models/DTO/UserModel";
import { DropdownType } from "../@types/Rd";
import { IProposalModel } from "../models/DTO/ProposalModel";
import { IAreaModel } from "../models/DTO/AreaModel";
import { IDeliberationPhrasesModel } from "../models/DTO/DeliberationPhrasesModel";
import { IUserCompanyPermissionModel } from "../models/DTO/UserCompanyPermissionModel";

const GetProperties = (obj: any): string[] => {
    if (!obj)
        throw new Error("Object could not be null.");

    const props: string[] = Object.keys(obj);

    return props;
}

export const HasProperty = (obj: any, name: string): boolean => {
    return obj != null && GetProperties(obj).some((x: string) => x.toLowerCase() === name.toLowerCase())
};

export const GetValue = (obj: any, name: string): any => {
    if (!name || name == "")
        throw new Error("Name of property could not be null or empty.");

    let result: any;

    if (HasProperty(obj, name)) {

        const props: string[] = GetProperties(obj),
            founded = props.find((prop: string) => prop.toLowerCase() === name.toLowerCase());

        if (founded && founded != "")
            result = obj[founded];
    }

    return result;
}

export class UIHelper {

    GetTextValueFromView = (propID: string): string => this.GetValueByPropertyID(propID);

    GetDatetimeValueFromView = (propID: string): Date => this.GetValueByPropertyID(propID);

    GetNumberValueFromView = (propID: string): number => this.GetValueByPropertyID(propID);

    GetSelectedValueFromView = (propID: string): string => {
        this.ValidatePoprtyID(propID);
        const result: string = this.GetValueBySelection(`select#${propID} option:checked`);
        return result;
    }

    IsCheckedInput = (propID: string): boolean => {
        this.ValidatePoprtyID(propID);

        const element: any = document.getElementById(propID),
            result: boolean = element && HasProperty(element, "checked") && element.checked === true;

        return result;
    }

    GetElement = (selection: string): JQuery<HTMLElement> | HTMLElement => this.GetElementBySelection(selection);

    private ValidatePoprtyID = (propID: string): void => {
        if (!propID || propID == "")
            throw new Error("Id of element could not be null or empty.");
    }

    private ValidatePropertySelection = (selection: string): void => {
        if (!selection || selection == "")
            throw new Error("Selection of property could not be null or empty.");
    }

    private GetValueByPropertyID<TType>(propID: string): TType {

        this.ValidatePoprtyID(propID);
        const result: TType = this.GetValueBySelection<TType>(`#${propID}`);
        return result;
    }

    private GetValueBySelection<TType>(selection: string): TType {
        this.ValidatePropertySelection(selection);

        const element: JQuery<HTMLElement> = $(selection),
            result: TType = element.val() as TType

        return result
    }

    private GetElementBySelection = (selection: string): JQuery<HTMLElement> | HTMLElement => {
        this.ValidatePropertySelection(selection);

        const result: JQuery<HTMLElement> = $(selection);
        return result;
    }
}

export const GetBytesFromFileAsync = async (file: File): Promise<Uint8Array> => {

    if (file == null || file.size == 0)
        throw new Error("File could not be null or empty");

    const buffer: ArrayBuffer = await file.arrayBuffer(),
        bytes: Uint8Array = new Uint8Array(buffer as ArrayBuffer);

    return bytes;
}

export const GetBytesFromFile = (file: File, callback: (bytes: Uint8Array | null, error: any) => void): void => {

    if (file == null || file.size == 0)
        throw new Error("File could not be null or empty");

    if (callback == null)
        throw new Error("Callback could nor be null.");

    const fileReader = new FileReader()

    fileReader.onload = (event: ProgressEvent<FileReader>) =>
        callback((event.target?.result && new Uint8Array(event.target.result as ArrayBuffer)) || null, event.target?.error);

    fileReader.onerror = (event: ProgressEvent<FileReader>) =>
        callback(null, event.target?.error);

    fileReader.readAsArrayBuffer(file);
}

export const ConvertToString = (buffer: ArrayBuffer): string => {
    if (buffer == null)
        throw new Error("Buffer could not be null.");

    const decoder: TextDecoder = new TextDecoder(),
        result: string = decoder.decode(buffer);

    return result;
}

export const NavigatorIdentifier = (): NavigatorType => {
    // Browser check variables
    // If you support IE, our recommendation is that you sign-in using Redirect APIs
    // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");
    const msie11 = ua.indexOf("Trident/");
    const msedge = ua.indexOf("Edge/");
    const firefox = ua.indexOf("Firefox");
    const chrome = ua.indexOf("Chrome");
    const isIE = msie > 0 || msie11 > 0;
    const isEdge = msedge > 0;
    const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito
    const isChrome = chrome > 0;

    if (isIE)
        return NavigatorType.IE;
    else if (isEdge)
        return NavigatorType.Edge;
    else if (isFirefox)
        return NavigatorType.Firefox;
    else if (chrome)
        return NavigatorType.Chrome;

    return NavigatorType.Unknow;
}

export class CustomNavigationClient extends NavigationClient {
    private navigate: NavigateFunction;

    constructor(navigate: NavigateFunction) {
        super();
        this.navigate = navigate;
    }

    /**
     * Navigates to other pages within the same web application
     * You can use the useNavigate hook provided by react-router-dom to take advantage of client-side routing
     * @param url
     * @param options
     */
    async navigateInternal(url: string, options: NavigationOptions) {
        const relativePath = url.replace(window.location.origin, "");
        if (options.noHistory) {
            this.navigate(relativePath, { replace: true });
        } else {
            this.navigate(relativePath);
        }

        return false;
    }
}

export const GetUtcDate = (date?: string | Date): string | undefined => {

    if (date != null && date != "") {
        let dateHandle: moment.Moment | undefined;

        try {
            dateHandle = moment((date as Date).toUTCString());
        }
        catch {
            dateHandle = moment(date)

        }

        if (dateHandle != null && dateHandle.isValid())
            return dateHandle.utc(true).format();
    }

    return undefined
}


export function CopyProps(source: any, target: any): any {

    if (!source)
        throw Error("Source could not be null.");

    if (!target)
        throw Error("Target could not be null.");

    if (typeof source != "object")
        throw new Error("Source must be an object.");

    if (typeof target != "object")
        throw new Error("Target must be an object.");

    const sourceProps: string[] = Object.keys(source),
        targetProps: string[] = Object.keys(target),
        matchedProps = sourceProps.filter((skey: string) => skey && skey != "" && targetProps.some((tKey: string) => tKey && tKey != "" && skey.toLocaleLowerCase() == tKey.toLocaleLowerCase()));

    if (matchedProps && matchedProps.some(x => x)) {

        for (let index = 0; index < matchedProps.length; index++) {
            const key = matchedProps[index];

            if (!Object.is(source[key], target[key]))
                throw new Error(`Type of property (${key}) does not match between 'Source' e 'Target'.`);

            target[key] = source[key];
        }
    }

    return target;
}

export function MountDictByCollection<TEntity>(collection: TEntity[], propertyKey: keyof TEntity) {
    const result = collection
        .reduce((map, item: any) => map.set(`${item[propertyKey]}`, item), new Map<string, TEntity>());

    return result;
}

/**
 * Get today date with time in value
 * @param value { string } - The date to get time.
 * @param locale {string } - Thr location with time handled.
 * @returns The today date with time in value (if value is not null or empty) otherwise undefined.
 */
export const HendleTimeGetter = (value: string, locale: string = "pt-BR"): Date | undefined => {

    if (value == null || value == "")
        return undefined;

    const hoursGetter: Intl.DateTimeFormat = new Intl.DateTimeFormat(locale, { hourCycle: "h24", hour: "2-digit", }),
        minutesGetter: Intl.DateTimeFormat = new Intl.DateTimeFormat(locale, { hourCycle: "h24", minute: "2-digit" }),
        secondsGetter: Intl.DateTimeFormat = new Intl.DateTimeFormat(locale, { hourCycle: "h24", second: "2-digit" }),
        date: Date = moment(value).toDate();

    const result: Date = moment()
        .locale(locale)
        .hour(hoursGetter.format(date) as any)
        .minute(minutesGetter.format(date) as any)
        .second(secondsGetter.format(date) as any)
        .subtract(1, "day")
        .toDate();

    return result;
}

export const HandleTimeSetter = (value: string, locale: string = "pt-BR"): moment.Moment | undefined => {
    if (value == null || value == "")
        return undefined;

    const [hours, minutes, seconds] = (value as string).split(":").map(Number),
        result = moment()
            .locale(locale)
            .set("hours", hours)
            .set("minutes", minutes || 0)
            .set("seconds", seconds || 0);

    return result;
}

export const TimeFormatter = (value: Date): string => moment(value!).format(moment.HTML5_FMT.TIME_SECONDS);

export const CheckValidDate = (value: string, prev: Date): Date => {
    const dummy = (value != null && value != "" && moment(value)) || undefined,
        result = (dummy != null && dummy.isValid() && dummy.toDate()) || prev

    return result;
}

export const IgnoreTimeZoneApiDate = (value: string): Date => {

    //TODO: check how will handle with timezones, the best fit will be came from API.
    //To this moment timezone will be removed

    if (value == null || value == "")
        throw Error("Value could not be null or empty.");

    const removeTimezone: string = value.replace("Z", ""),
        momentDate: moment.Moment = moment(removeTimezone),
        result: Date = momentDate.toDate();

    return result;
}

export const GetDefaultOption = (): DropdownType => {
    const result: DropdownType = { Caption: "Selecione", Value: "" };
    return result;
}

export const GetAreasOptions = (collection: IAreaModel[], proposal: IProposalModel | undefined = undefined): DropdownType[] => {
    const result = [
        GetDefaultOption(),
        ...collection
            .map(area => {
                const result: DropdownType = {
                    Caption: area.Name!,
                    Value: area.Id,
                    IsSelected: proposal != null && proposal.Areas != null && proposal.Areas.some(pArea => pArea.Id == area.Id)
                }

                return result;
            })
    ]

    return result;
}

export const GetCompaniesOptions = (collection: ICompanyModel[], proposal: IProposalModel | undefined = undefined, auth: { userInfo: IUserModel, permissions: Map<string, IUserCompanyPermissionModel> } | undefined = undefined): DropdownType[] => {
    const result = [
        GetDefaultOption(),
        ...collection
            .filter(company => {

                if (auth == null) return true;

                const permission = auth.permissions.get(`${auth.userInfo.Id}|${company.Id}`);

                if (permission == null) return false;

                const result = permission.HasOneValidPermission();

                return result;
            })
            .map(company => {
                const item: DropdownType = {
                    Caption: company.Name!,
                    Value: company.Id,
                    IsSelected: proposal != null && proposal.Companies != null && proposal.Companies.some(y => y.Id == company.Id)
                };

                return item;
            })
    ]

    return result;
}

export const GetMeetingOptions = (collection: IBoardMeetingModel[]): DropdownType[] => {
    const result = [
        GetDefaultOption(),
        ...collection
            .map(meeting => {
                const result: DropdownType = {
                    Caption: `${moment(meeting.StartTime?.toISOString()).format("DD/MM/YYYY")} - ${meeting.RdNumber} - ${meeting.Name}`,
                    Value: meeting.Id,
                }

                return result;
            })
    ]

    return result;
}

export const GetUserOptions = (collection: IUserModel[]): DropdownType[] => {
    const result = [
        GetDefaultOption(),
        ...collection
            .map(user => {
                const item: DropdownType = {
                    Caption: user.Name!,
                    Value: user.Id
                }

                return item;
            })
    ]
    return result;
}

export const GetDeliberationPhrasesOptions = (collection: IDeliberationPhrasesModel[]): DropdownType[] => {
    const result = [
        GetDefaultOption(),
        ...collection
            .map(phrase => {
                const item: DropdownType = {
                    Caption: phrase.Phrase,
                    Value: phrase.Id,
                }

                return item;
            })
    ]

    return result
}

export const NumberRange = (start: number, end: number, step: number = 1): ReadonlyArray<number> => {
    const result: number[] = Array.from(
        { length: (end - start) / step + 1 },
        (value, index) => start + index * step
    );

    return result;
}

export const FixFooterPosition = (): void => {

    const uiHelper: UIHelper = new UIHelper(),
        jqFooter: JQuery<HTMLElement> = (uiHelper.GetElement("#rdFooter") as JQuery<HTMLElement>),
        jqContent: JQuery<HTMLElement> = (uiHelper.GetElement("#rdContent") as JQuery<HTMLElement>),
        windowsHeight = window.innerHeight,
        contentHeight = jqContent.innerHeight() || 0,
        footerHeight = jqFooter.innerHeight() || 0,
        elFooter = jqFooter.length > 0 ? jqFooter[0] : undefined;

    if (elFooter != null) {
        let scrollOffset = 6,
            topOffSet = 10,
            top: number = (windowsHeight - footerHeight);

        if (window.innerWidth <= 411) {
            // elFooter.style.setProperty("margin-left", "-2.95%");
            scrollOffset = 3.2;
            topOffSet = 40
        }

        if (window.innerWidth > 412 && window.innerWidth <= 823) {
            // elFooter.style.setProperty("margin-left", "-1.49%");
            scrollOffset = 0;
        }

        if (window.innerWidth > 823) {
            // elFooter.style.setProperty("margin-left", "-0.65%");
        }

        if (contentHeight > windowsHeight)
            top = contentHeight + topOffSet
        else if ((windowsHeight - footerHeight) == contentHeight)
            top = (windowsHeight - footerHeight) + topOffSet;
        else
            top = windowsHeight;

        // elFooter.style.setProperty("top", `${top}px`);
        elFooter.style.setProperty("width", `${window.innerWidth - scrollOffset}px`);
    }
}

export function GroupBy<TType>(collection: TType[], propertyName: keyof TType): Map<string, TType[]> {
    const result = collection
        .reduce((map, item) => map.set(item[propertyName] as string, [...map.get(propertyName as string) || [], item]), new Map<string, TType[]>());

    return result;
}

// export function groupBy<TType>(arr: TType[], fn: (item: TType) => any) {
//     return arr.reduce<Record<string, TType[]>>((prev, curr) => {
//         const groupKey = fn(curr);
//         const group = prev[groupKey] || [];
//         group.push(curr);
//         return { ...prev, [groupKey]: group };
//     }, {});
// }

export function groupBy<TType>(arr: TType[], fn: (item: TType) => any) {
    return arr.reduce<Map<string, TType[]>>((map, curr) => {
        const groupKey = fn(curr);
        return map.set(groupKey, [...map.get(groupKey) || [], curr]);
    }, new Map());
}

export const IsNumber = (text: string): boolean => (text != null && text.trim() != "" && new RegExp(/[0-9]/).test(text.trim()));


export const Zip: <TData1 = unknown, TData2 = unknown>(collection1: Array<TData1>, collection2: Array<TData2>) => Array<[TData1, TData2]> = (collection1, collection2) =>
    Array.from(Array(Math.max(collection1.length, collection2.length)), (_, i) => [collection1[i], collection2[i]]);

// /**
//  * Zips any number of arrays. It will always zip() the largest array returning undefined for shorter arrays.
//  * @param  {...Array<any>} arrays
//  */
// export function* Zip(...arrays: Array<any>) {
//     const maxLength = arrays.reduce((max, curIterable) => curIterable.length > max ? curIterable.length : max, 0);
//     for (let i = 0; i < maxLength; i++) {
//         yield arrays.map(array => array[i]);
//     }
// }

// /**
// * Zips any number of iterables. It will always zip() the largest Iterable returning undefined for shorter arrays.
// * @param  {...Iterable<any>} iterables
// */
// export function* Zip(...iterables: any[]) {
//     // get the iterator of for each iterables
//     const iters = [...iterables].map((iterable) => iterable[Symbol.iterator]());
//     let next = iters.map((iter) => iter.next().value);
//     // as long as any of the iterables returns something, yield a value (zip longest)
//     while (anyOf(next)) {
//         yield next;
//         next = iters.map((iter) => iter.next().value);
//     }

//     function anyOf(arr: any[]) {
//         return arr.some((v: any) => v !== undefined);
//     }
// }

/**
 * T extends empty object. U extends the keys of T. Therefore U will always exist on T, therefore it can be used as a look up value.
 * Bibliography: https://stackoverflow.com/questions/57086672/element-implicitly-has-an-any-type-because-expression-of-type-string-cant-b#answer-60274490
 * @param key 
 * @returns 
 */
export const getKeyValue = <TObj, TProp extends keyof TObj>(obj: TObj, key: TProp): TObj[TProp] => obj[key];

export const Swap = <TData extends any>(array: TData[], idxOrigin: number, idxTarget: number): TData[] => {
    [array[idxOrigin], array[idxTarget]] = [array[idxTarget], array[idxOrigin]];
    return array;
}

export const DelayAsync = async (ms: number) => await new Promise<void>(resolve => setTimeout(resolve, ms));

export const CharCount = (text: string, char: string): number => (text.match(new RegExp(char, "g")) || []).length;